import React, { useState } from 'react';
import { useListFeatureIdentities } from './hooks/useListFeatureIdentities';
import { FeatureIdentitiesTable } from './FeatureIdentitiesTable';
import { FeatureUserForm } from './subComponents/FeatureUserForm';
import { FeaturePresentationCard } from './FeaturePresentationCard';

export const FeatureIdentitiesContainer: React.FC = () => {
  const { sortedFeatureIdentityData, featureIdentityError, isFeatureIdentityFetching } = useListFeatureIdentities();
  const [addFeatureIdentity, setAddFeatureIdentity] = useState(false);

  const handleAddClick = () => {
    setAddFeatureIdentity(true);
  };

  const onCancel = () => {
    setAddFeatureIdentity(false);
  };

  return (
    <FeaturePresentationCard
      featureFetchError={featureIdentityError}
      title={'Features By User'}
      hintText={'Allow specific users to access features.'}
      buttonText={'Add New Feature for User'}
      handleAddClick={handleAddClick}
      data-test-class={'feature-identities-page'}
    >
      {addFeatureIdentity && <FeatureUserForm onCancel={onCancel} />}
      <FeatureIdentitiesTable featureIdentityData={sortedFeatureIdentityData} isLoading={isFeatureIdentityFetching} />
    </FeaturePresentationCard>
  );
};
